import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { AuthService } from '../../../pages/user/services/auth.service';
import { LocalStorageService } from '../../../pages/user/services/local-storage.service';
import { DataSharingService } from '../../../pages/user/services/data-sharing.web.service';
import { CacheService } from '../../../shared/services/cache.service';
import { MenuSharedService } from '../menu/services/menu.shared.service';
import { AppRoutes } from '../../../shared/constants/routes/routes.constant';
import getImageUrl from '../../../shared/utils/get-profile-pic';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  loggedUser: any;
  avatarUrl: SafeStyle | null = null;
  userInitials: string = '';
  // Precisão: Esta variável controla EXCLUSIVAMENTE se as iniciais aparecem.
  showInitials: boolean = true;

  constructor(
    private auth: AuthService,
    private router: Router,
    private localStorage: LocalStorageService,
    private dataSharingService: DataSharingService,
    private sanitizer: DomSanitizer,
    private cacheService: CacheService,
    private menuSharedService: MenuSharedService
  ) { }

  ngOnInit() {
    this.loggedUser = this.localStorage.getObject('user');

    if (this.loggedUser && this.loggedUser.name) {
      this.userInitials = this.getInitials(this.loggedUser.name);
    }

    // Escuta o serviço de avatar
    this.dataSharingService.getLoggedUserAvatar().subscribe((url) => {
      this.avatarUrl = url;
      // Se 'url' for null ou undefined, mostramos as iniciais.
      // Como 'url' pode ser um objeto SafeStyle, a verificação '!!url' falha.
      // Por isso, os métodos setAvatar() abaixo controlam showInitials manualmente.
    });

    this.checkAvatarVisibility();
  }

  private checkAvatarVisibility() {
    if (!this.loggedUser) {
      this.showInitials = true;
      return;
    }

    const pic = this.loggedUser.profile_photo_url;
    const id = this.loggedUser.photo_id;

    // Função para validar se o dado é realmente útil
    const isValid = (val: any) => val && val !== 'null' && val !== 'undefined';

    if (isValid(pic)) {
      this.setAvatar(pic);
      this.showInitials = false;
    } else if (isValid(id)) {
      this.setAvatar(getImageUrl(id, 55, 55));
      this.showInitials = false;
    } else {
      this.dataSharingService.setLoggedUserAvatar(null);
      this.avatarUrl = null;
      this.showInitials = true;
    }
  }

  private setAvatar(url: string) {
    this.dataSharingService.setLoggedUserAvatar(
      this.sanitizer.bypassSecurityTrustStyle(`url(${url})`)
    );
  }

  getInitials(name: string): string {
    if (!name) return '';
    const names = name.trim().split(/\s+/).filter(n => n.length > 0);
    if (names.length === 0) return '';

    const firstChar = names[0].charAt(0).toUpperCase();
    const lastChar = names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : '';
    return firstChar + lastChar;
  }

  toggleMenu() {
    this.menuSharedService.setMenuCollapsed(false);
  }

  logout() {
    this.dataSharingService.setLoggedUserAvatar(null);
    this.menuSharedService.setMenuCollapsed(true);
    this.dataSharingService.setOrganizacaoData(null);
    this.dataSharingService.setTerminalLiberacaoData(null);
    this.cacheService.clearCache();
    this.router.navigate([AppRoutes.LOGOUT]);
    this.auth.logout();
  }
}
